export default {
    title: "Twój menedżer zatwierdzający to {email}"
}